<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/03_Parchi-Riserve/03c_Serre_Bosco-Archiforo.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Parco Regionale delle Serre</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a class="active">Parco Regionale delle Serre</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Il comprensorio delle Serre si trova tra la Sila e l’Aspromonte. Costituisce un gruppo montuoso articolato che vede alternarsi valli, 
            boschi, fiumare e tantissime sorgenti. Nelle Serre orientali, i corsi d’acqua diventano impetuosi torrenti che con il loro fluire creano incredibili forre,
             gole strettissime e splendide cascate come quelle del Marmarico o quelle della fiumara Assi. Tanti sono gli animali che abitano l’area, in particolare,
              emblemi di questa terra suggestiva sono, oltre al lupo, l’istrice e il gatto selvatico. La zona delle Serre, inoltre,
               è caratterizzata da molte antiche produzioni artigianali come la lavorazione della lana e della seta o quella del legno.
                È possibile quindi, non solo intraprendere un itinerario tra le meraviglie della natura, ma anche scoprire quelle manifatture originali e introvabili, 
                come le pipe a Brognaturo o i vasi di terracotta per la conservazione e la cottura dei cibi a Sorianello e Gerocarne. 
        </p>
    </div>
</div>
<br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-9 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Regionale delle Serre.</p>
    </div>
    <div class="col-3 col-xl-1">
        <img style="width: 65%;" src="../../../assets/images/Logo-Parco-1024x1024.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Serra San Bruno</h1>
                        <a (click)="goToSerraSanBruno()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Girifalco</h1>
                        <a (click)="goToGrifalco()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>